import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { isArray } from 'rxjs/internal-compatibility';
import { AttachingCertificateComponent, TagsDialogManagmentComponent, TagsListComponent } from 'src/app/components/dialog';
import { FileData, Product, ReferenceParams, Res } from 'src/app/models';
import { AddinfoService, DialogModalService, FilesService, PermissionService } from 'src/app/services';
import { ApiAttributesEditableContentService } from 'src/app/services/api-attributes-editable-content.service';

@Component({
  selector: 'app-editable-content',
  templateUrl: './editable-content.component.html',
  styleUrls: ['./editable-content.component.css']
})
export class EditableContentComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  product_ids: string[] = [];
  attrType: Object;
  attrValueType: Object;
  contentValueType:string;
  attributeId: string;
  contentType: string;
  contentId: string;
  contentValue: any;
  displayContentValue: string;
  attributeAdditionalData: any;
  referencesValue: any;
  itemsLoading: boolean;
  tags: any[] = [];
  defaultStyle:boolean = true;

  
  form: UntypedFormGroup = this.fb.group({
    value: [null]
  });

  @Input() set inputValue(inputData: any) {

    console.log("INPUT ATTRS DATA: ", inputData);


    if (inputData) {

      if(inputData.productData != null){

        isArray(inputData.productData) ? this.product_ids = inputData.productData : this.product_ids.push(inputData.productData);
      }

      this.attrType = this.addinfoService.attrType;
      this.attrValueType = this.addinfoService.attrValueType;
      this.contentValueType = inputData.attrsData.attribute_value_type;
      this.attributeId = inputData.attrsData.id;
      this.contentType = inputData.attrsData.present_type_id;
      this.contentId = inputData.attrsData.present_content_id;
      this.contentValue = inputData.attrsData.value;
      this.displayContentValue = inputData.attrsData.display_value;
      this.attributeAdditionalData = inputData.attrsData.attribute_additional_info;
      this.defaultStyle = inputData.defaultStyle;

      if(this.contentId){

        this.getAttrsContent(this.contentId);
      }
      
      if (this.contentType == 'COMBOBOX_MULTIPLE' && this.contentValue && this.contentValue != 'null' && !isArray(this.contentValue)) {

        this.contentValue != '' ? this.form.get('value').setValue(this.contentValue.split(",")) : this.form.get('value').setValue(null);


      } else if (this.contentType == 'COMBOBOX_MULTIPLE' && this.contentValue && this.contentValue != 'null' && isArray(this.contentValue)) {

        this.form.get('value').setValue(this.contentValue);


      } else if (this.contentType == 'COMBOBOX' && this.contentValue && this.contentValue != 'null') {

        this.form.get('value').setValue(this.contentValue);


      } else if((this.contentType == 'CERTIFICATE' || this.contentType == 'FILE' || this.contentType == 'TAGS') && this.contentValue && this.contentValue != 'null'){

        this.form.get('value').setValue(this.contentValue);
      }
      
      else {

        if (isArray(this.contentValue)) {

          this.referencesValue = this.contentValue;
        }
        this.form.get('value').setValue(this.displayContentValue);


        console.log("DISPLAY VALUE: ", this.displayContentValue);
        
      }
    }

    if (this.contentType == 'TAGS' && this.attributeAdditionalData != null) {

      this.passSecurity(this.attributeAdditionalData);
    }
  }

  @Output() outputValue = new EventEmitter();
  @Output() outputReject = new EventEmitter();

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiEditableContent: ApiAttributesEditableContentService,
    private dialogModal: DialogModalService,
    private filesService: FilesService,
    private addinfoService: AddinfoService,
    private sanitizer: DomSanitizer,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

  }

  /**
   * 
   * @param event 
   */
  onChange(event) {

    this.outputValue.emit(event);
  }

  /**
   * 
   */
  passSecurity(attrs: any) {

    let primitiveParams: string;

    attrs.forEach(attr => {

      primitiveParams = attr.graphic_primitive.primitive_params
      primitiveParams = primitiveParams.replace('color', attr.color)
      attr['tagHtml'] = this.sanitizer.bypassSecurityTrustHtml(primitiveParams) as SafeHtml;

    });
  }

  /**
  * 
  * @param styles 
  * @returns 
  */
  getTagStyle(styles) {
    return {
      width: styles.width + styles.width_height_unit,
      height: styles.height + styles.width_height_unit,
      display: 'block',
      margin: '0 5px 0 0'
    }
  }

  /**
   * 
   * @param searchValue - значение для поиска вводимое вручную
   * @param currentElemId - текущее значение из справочника передаваемое при его выборе из списка
   */
  getAttrsContent(inputId: string): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_presets_content',
      filter: {
        "preset_content_id": inputId
      }
    }

    this.itemsLoading = true;

    this.subscriptions.add(
      this.apiEditableContent.getReferences(params, params.ref_name).subscribe((response: Res) => {console.log("REFERENCES: ", response);
      

        if (response != null) {

          this.referencesValue = response.result;

        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );
  }
  
  /**
  * 
  * @param i 
  * @param j 
  * @param attribute_id 
  */
  onCreateTags(): void {

    let data = {
      tagsIds: this.attributeAdditionalData != null ? this.attributeAdditionalData.map(val => val.id) : null
    };

    this.dialogModal.open(data, TagsListComponent, '', 'tags-window').then(
      (result) => {

        if (result) {

          this.form.get('value').setValue(result.map(t => t.id).join());
          this.attributeAdditionalData = result;

          // Проверка на дефолтные настройки(применяется в списке продуктов)
          if(!this.defaultStyle){
            this.updateList();
          }

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param tag 
   */
   onDeleteTag(tag: any) {

    let tagsIds: string[] = this.form.get('value').value != null ? this.form.get('value').value.split(',') : [];

    let positionTagId: number = tagsIds.indexOf(tag.id);
    let positionTag: number = this.attributeAdditionalData.indexOf(tag);

    if (~positionTagId) tagsIds.splice(positionTagId, 1);
    this.form.get('value').setValue(tagsIds.join());

    this.attributeAdditionalData.splice(positionTag, 1);

    if(!this.defaultStyle){
      this.updateList();
    }
    
  }


  /**
   * 
   */
  onCreateFile(file:FileData){

    this.attributeAdditionalData = [];

    this.form.get('value').setValue(file.id);
    this.attributeAdditionalData.push(file);
    
  }

  /**
   * 
   * @param tag 
   */
   onDeleteFile() {

    this.form.get('value').setValue('');
    this.attributeAdditionalData.splice(0, 1);

  }

  /**
   * Скачивание файлов
   * @param file FileData
   */
   downloadFile(file: FileData): void {

    this.filesService.downloadFile(file.name, file.id);
  }

  /**
   * Открытие диалогового окна для создания и прикрепления Сертификата
   * !!! ТРЕБУЕТСЯ ДОРАБОТКА, ВЫБОР ИЗ УЖЕ РАНЕЕ ЗАГРУЖЕННЫХ СЕРТИФИКАТОВ/ФАЙЛОВ
   * @param i number
   * @param j number
   * @param attribute_id string
   */
   openDialogCreateCert(): void {

    let data = {
      type: 'create',
      cert_type: this.attributeId,
      product_ids: this.product_ids,
    };

    this.dialogModal.open(data, AttachingCertificateComponent).then(
      (result) => {

        if (result) {

          this.form.get('value').setValue(result.id);
          
          this.attributeAdditionalData = result;
           // Проверка на дефолтные настройки(применяется в списке продуктов)
           if(!this.defaultStyle){
            this.updateList();
          }
          
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  onDeleteCertificate(){

    this.form.get('value').setValue('');
    this.attributeAdditionalData = null;
  }

  /**
   * 
   */
  closeAction() {

    this.outputReject.emit(true);
  }

  /**
   * 
   */
  updateList(): any {

    let displayValue: string = '';


    let outPutData = {
      content_type: this.contentType,
      value: this.form.get('value').value,
      attrs_addInfo_data: this.attributeAdditionalData ? this.attributeAdditionalData : null
    }

    console.log("OUTPUT DATA: ", outPutData);
    
    if (this.contentType == 'COMBOBOX_MULTIPLE') {

      if(this.form.get('value').value){

        this.form.get('value').value.forEach(element => {
          displayValue = displayValue + ', ' + this.referencesValue.find(val => val.id == element).name;
        });
  
        displayValue = displayValue.substring(2, displayValue.length);
      }

      outPutData['display_value'] = displayValue;
    }

    if (this.contentType == 'COMBOBOX') {
      
      displayValue = this.form.get('value').value ? this.referencesValue.find(val => val.id == this.form.get('value').value).name : '';
      outPutData['display_value'] = displayValue;
    }

    this.outputValue.emit(outPutData);
  }
}
